var TRANSFORMS = {};
var PARSERS = {};
export var getParser = function getParser(type) {
  return PARSERS[type];
};
export var registerParser = function registerParser(type, parserFunction) {
  PARSERS[type] = parserFunction;
};
export var getTransform = function getTransform(type) {
  return TRANSFORMS[type];
};
export var registerTransform = function registerTransform(type, transFunction) {
  TRANSFORMS[type] = transFunction;
};
//# sourceMappingURL=factory.js.map